export const mapTree = (originTree) => {
    if (originTree?.length > 0) {
        const res = originTree.map((tag, index) => ({
            key: `${tag.orgUserVo.id}-${tag.orgUserVo.type}`,
            id: tag.orgUserVo.id,
            label: tag.orgUserVo.name,
            parent: tag.subOrgUserVo?.length > 0,
            type: tag.orgUserVo.type,
            children: mapTree(tag.subOrgUserVo),
        }));
        return res;
    }
    else {
        return [];
    }
};
export const mapTags = (res) => {
    if (!res) {
        return [];
    }
    const mappedTag = res.users?.length > 0 ? res.users.map((item) => { return { id: item.id, label: item.realName, type: item.type }; }) : [];
    return mappedTag;
};
